import './LoaderOverlay.css'

type Props = {
  visible: boolean
  children?: React.ReactNode
}

export const LoaderOverlay = ({ visible, children }: Props) => {
  if (!visible) return null

  return (
    <div style={styles.overlay}>
      <div style={styles.content}>{children ?? <div className="spinner" />}</div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  //   overlay: {
  //     position: 'fixed',
  //     inset: 0,
  //     backgroundColor: 'rgba(0,0,0,0.5)', // dim effect
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //     zIndex: 9999,
  //   },
  overlay: {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  content: {
    pointerEvents: 'auto',
  },
}
